// Local translations
export const T = {
  en_GB: {
    saving: "Saving...",
    goalName: "Goal Name",
    goalNamePlaceholder: "e.g., Retirement Fund",
    failedToSetPlatform: "Failed to set platform",
    error: "Error",
    failedToSave: "Failed to save goal",
    incompleteMessage: "Complete goal details before submitting",
  },
  nb_NO: {
    saving: "Lagrer...",
    goalName: "Målnavn",
    goalNamePlaceholder: "f.eks., Pensjonsfond",
    failedToSetPlatform: "Kunne ikke velge plattform",
    error: "Feil",
    failedToSave: "Kunne ikke lagre mål",
    incompleteMessage: "Fyll inn måldetaljer før innsending",
  },
} as const;
